module.exports = __webpack_public_path__ + "static/media/icon-1.a8e7d898.svg";